export default __webpack_public_path__ + "static/media/hm-sbo-img.4b3fdcbe.webp";